export const isAdmin = (value) => {
  return ['admin', 'admin_with_beta_firmware_access'].includes(value);
}

export const convertUserTypeToLabel = (value) => {
  if (value === "admin") return "Admin";
  if (value === "admin_with_beta_firmware_access") return "Admin + Beta Firmware Access";
  if (value === "prosthetist") return "Prosthetist";
  return null;
}